<template>
<div  :aria-busy="loading ? 'true' : 'false'">
	<div v-if="!loading">
		<section class="content__custom">
			<div class="main-title">
				<h1 class="logs">
					{{ 'activities-register' | translate }}
				</h1>
				<h2>{{ 'supporters-subtitle' | translate | capitalize }}</h2>
			</div>
			<div v-if="logs">
				<div v-if="logs.length > 0">
					<table class="table--fixed">
						<thead>
							<tr>
								<th class="name-cell">{{ 'logs' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
							</tr>
						</thead>
						<tfoot v-if="logs.length >= 10">
							<tr>
								<th class="name-cell">{{ 'logs' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="log in logs" :key="log.id">
								<td :title="'logs' | translate" class="name-cell">{{ log.description }}</td>
								<td :title="'data' | translate" class="date-cell">{{ log.created_at | date }}</td>
							</tr>
						</tbody>
					</table>
					<pagination
					:classNames="'pagination-arrows pull-right'"
					dispatchToCall="getLogs"
					:itemsPerPageProp="session.results"
					:totalItensPagesProps="totalPages"
					:totalItens="totalItems"
					:totalPagesProp="this.totalPages"
					></pagination>

				</div>
				<div class="content-empty" v-else>
					<p class="empty-state">{{ 'no-logs' | translate | capitalize }}</p>
				</div>
			</div>
		</section>
	</div>
</div>
</template>
<script>

import alert from '../../components/alert/alert.vue';
import pagination from '../../components/pagination/pagination.vue';

export default {
	name: 'log',
	components: {
		alert,
		pagination,
	},
	data() {
		return {
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
		};
	},
	computed: {
		logs: {
			get() {
				return (this.$store.state.log.logs || {}).logs || {};
			},
			set() {
			},
		},
		totalItems() {
			return (this.$store.state.log.logs || 0).itens_count || 0;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getLogs', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
	watch: {
		logs() {
			if (this.$store.state.activities.logs.logs) {
				this.totalPages = this.$store.state.activities.logs.logs;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/log/log.vue